"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _polished = require("../helpers/polished");
var _recompose = require("../recompose");
var _styled = _interopRequireWildcard(require("../styled"));
var _text = require("../text");
var _withClickOutside = _interopRequireDefault(require("../withClickOutside"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var HeaderItem = (0, _styled.default)(_text.Paragraph)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: left;\n  padding: ", ";\n  background: ", ";\n  margin: 0;\n"])), (0, _styled.rem)(10), (0, _styled.prop)('theme.colors.backgroundPrimary'));
var ListItemWrapper = _styled.default.li(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n  cursor: pointer;\n  width: 100%;\n  min-width: ", ";\n  border: 1px solid ", ";\n  margin-bottom: ", ";\n  list-style-type: none;\n"])), (0, _styled.rem)(180), (0, _styled.theme)('colors.border'), (0, _styled.theme)('grid.gutter') / 2);
var ListItem = _styled.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)([""])));
var DropDown = _styled.default.ul(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: left;\n  width: 100%;\n  padding-left: 0;\n  border-top: none;\n  background: white;\n  list-style-type: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"])));
var DropDownItemWrapper = _styled.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-height: ", ";\n  overflow: auto;\n  border-bottom: 1px solid ", ";\n  overflow-x: hidden;\n"])), (0, _styled.rem)(250), (0, _styled.theme)('colors.border'));
var lightText = function lightText(amount) {
  return (0, _styled.withProp)('theme.colors.primary', (0, _polished.tint)(amount));
};
var DropDownItem = _styled.default.li(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  cursor: ", ";\n  background: ", ";\n  list-style-type: none;\n  padding: ", ";\n"])), (0, _styled.ifProp)('enabled', (0, _styled.prop)('theme.colors.primary'), lightText(0.5)), (0, _styled.ifProp)('enabled', 'pointer', 'default'), (0, _styled.ifProp)('selected', (0, _styled.theme)('colors.border'), (0, _styled.theme)('colors.backgroundPrimary')), (0, _styled.rem)(10));
var StyledIcon = _styled.default.span(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteralLoose2.default)(["\n  float: right;\n  > svg {\n    pointer-events: none;\n  }\n"])));
var isSelected = function isSelected(selected, value) {
  if (selected === value) {
    return true;
  }
  var parts = selected && selected.split('+') || [];
  var match = false;
  parts.forEach(function (part) {
    if (part === value) {
      match = true;
    }
  });
  return match;
};
var Dropdown = function Dropdown(_ref) {
  var options = _ref.options,
    selected = _ref.selected,
    header = _ref.header,
    children = _ref.children,
    select = _ref.select,
    expanded = _ref.expanded,
    toggle = _ref.toggle;
  return /*#__PURE__*/_react.default.createElement(ListItemWrapper, {
    onClick: toggle,
    expanded: expanded,
    "data-cy": "Dropdown"
  }, /*#__PURE__*/_react.default.createElement(ListItem, {
    expanded: expanded
  }, /*#__PURE__*/_react.default.createElement(HeaderItem, null, header(selected), /*#__PURE__*/_react.default.createElement(StyledIcon, null, expanded ? '–' : '+')), expanded && /*#__PURE__*/_react.default.createElement(DropDownItemWrapper, null, /*#__PURE__*/_react.default.createElement(DropDown, null, options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(DropDownItem, {
      key: option.value,
      enabled: option.enabled,
      selected: isSelected(selected, option.value),
      onClick: function onClick() {
        return option.enabled && select(option.value);
      }
    }, children(option.value));
  })))));
};
Dropdown.defaultProps = {
  selected: null,
  children: function children(value) {
    return value;
  },
  header: function header(value) {
    return value;
  }
};
var enhance = (0, _recompose.compose)((0, _recompose.withState)('expanded', 'setExpanded', false), (0, _recompose.withHandlers)({
  toggle: function toggle(_ref2) {
    var setExpanded = _ref2.setExpanded;
    return function () {
      return setExpanded(function (expanded) {
        return !expanded;
      });
    };
  }
}), (0, _withClickOutside.default)(function (_ref3) {
  var setExpanded = _ref3.setExpanded;
  return setExpanded(false);
}));
var _default = exports.default = enhance(Dropdown);